// extracted by mini-css-extract-plugin
export default {"ModalTitle":"ModalTitle_ModalTitle__TwHzS","text":"ModalTitle_text__UQN6M","closeBtn":"ModalTitle_closeBtn__tUvQe"};